// Generated types for Action
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ActionKind, NISTFunctionVerb, VerdictKind, VerificationMethod } from '../enums';

import { ActionInputParameterWriteAPI } from './actioninputparameter';
import { ActionOutputParameterWriteAPI } from './actionoutputparameter';
import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { ActionInputParameterWriteAPISchema } from './actioninputparameter';
import { ActionOutputParameterWriteAPISchema } from './actionoutputparameter';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ActionReadAPI extends RFLPElementReadAPI {
  /** FUNCTIONAL (default) or VERIFICATION_CASE. */
  kind?: ActionKind;
  /** NIST primary verb: what the Action does (its flow is on its parameters / flows, not here). convert: change form; transfer: pass between components; transport: move along a path; transmit: move with no material carrier; channel: direct along a fixed path; store: accumulate; supply: deliver continuously, provision: make available on demand; regulate: adjust, control_magnitude: hold a set level; signal: convey information about a flow; actuate: start a flow; separate: by component, distribute: to several destinations equally, branch: at a decision point. */
  function_verb?: NISTFunctionVerb | null;
  /** Preconditions on system state before this action runs. */
  preconditions?: string | null;
  /** Postconditions guaranteed on completion. */
  postconditions?: string | null;
  /** Only meaningful when kind=VERIFICATION_CASE. */
  verification_method?: VerificationMethod | null;
  /** Only meaningful when kind=VERIFICATION_CASE. */
  verdict?: VerdictKind | null;
  /** Link to test report / analysis doc / inspection record. */
  evidence_url?: string | null;
}

export interface ActionWriteAPI extends RFLPElementWriteAPI {
  /** FUNCTIONAL (default) or VERIFICATION_CASE. */
  kind?: ActionKind;
  /** NIST primary verb: what the Action does (its flow is on its parameters / flows, not here). convert: change form; transfer: pass between components; transport: move along a path; transmit: move with no material carrier; channel: direct along a fixed path; store: accumulate; supply: deliver continuously, provision: make available on demand; regulate: adjust, control_magnitude: hold a set level; signal: convey information about a flow; actuate: start a flow; separate: by component, distribute: to several destinations equally, branch: at a decision point. */
  function_verb?: NISTFunctionVerb | null;
  /** Preconditions on system state before this action runs. */
  preconditions?: string | null;
  /** Postconditions guaranteed on completion. */
  postconditions?: string | null;
  /** Only meaningful when kind=VERIFICATION_CASE. */
  verification_method?: VerificationMethod | null;
  /** Only meaningful when kind=VERIFICATION_CASE. */
  verdict?: VerdictKind | null;
  /** Link to test report / analysis doc / inspection record. */
  evidence_url?: string | null;
  parent?: string;
  sub_actions?: (string | ActionWriteAPI)[];
  /** Requirements this Action satisfies. */
  satisfies?: string[];
  /** Requirements this Action verifies (when kind=VERIFICATION_CASE). */
  verifies?: string[];
  /** LogicalParts that perform this Action. */
  performed_by?: string[];
  /** Input pins of this Action (data flows IN). */
  input_parameters?: (string | ActionInputParameterWriteAPI)[];
  /** Output pins of this Action (data flows OUT). */
  output_parameters?: (string | ActionOutputParameterWriteAPI)[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ActionReadAPISchema: z.ZodType<ActionReadAPI> = RFLPElementReadAPISchemaObject.extend({
  kind: z.nativeEnum(ActionKind).optional(),
  function_verb: z.nativeEnum(NISTFunctionVerb).nullable().optional(),
  preconditions: z.string().nullable().optional(),
  postconditions: z.string().nullable().optional(),
  verification_method: z.nativeEnum(VerificationMethod).nullable().optional(),
  verdict: z.nativeEnum(VerdictKind).nullable().optional(),
  evidence_url: z.string().nullable().optional(),
}).passthrough();

export const ActionWriteAPISchema: z.ZodType<ActionWriteAPI> = RFLPElementWriteAPISchemaObject.extend({
  kind: z.nativeEnum(ActionKind).optional(),
  function_verb: z.nativeEnum(NISTFunctionVerb).nullable().optional(),
  preconditions: z.string().nullable().optional(),
  postconditions: z.string().nullable().optional(),
  verification_method: z.nativeEnum(VerificationMethod).nullable().optional(),
  verdict: z.nativeEnum(VerdictKind).nullable().optional(),
  evidence_url: z.string().nullable().optional(),
  parent: z.string().optional(),
  sub_actions: z.array(z.union([z.string(), z.lazy(() => ActionWriteAPISchema)])).optional(),
  satisfies: z.array(z.string()).optional(),
  verifies: z.array(z.string()).optional(),
  performed_by: z.array(z.string()).optional(),
  input_parameters: z.array(z.union([z.string(), z.lazy(() => ActionInputParameterWriteAPISchema)])).optional(),
  output_parameters: z.array(z.union([z.string(), z.lazy(() => ActionOutputParameterWriteAPISchema)])).optional(),
}).passthrough();
